// import React, { useState } from "react";
// import logo from "../assets/img/street-logo.png";
// import { API_URL } from "../config"; // Import the global API URL
// import { useNavigate } from "react-router-dom";
// import { initializePermissions } from "../helpers/permission"; // add this import


// const Login = () => {
//   const [identity, setIdentity] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [loading, setLoading] = useState(false); // Track loading state
//   const navigate = useNavigate(); // Initialize useNavigate hook

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Basic validation
//     if (!identity || !password) {
//       setErrorMessage("Username and password are required.");
//       return;
//     }

//     setErrorMessage(""); // Reset previous error
//     setLoading(true); // Start loading

//     // Prepare the data to be sent to the API
//     const loginData = {
//       identity, // Username or email
//       password, // Password
//     };

//     try {
//       // Make the POST request to the API
//       const response = await fetch(`${API_URL}auth/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(loginData),
//       });

//       const data = await response.json();

//       // Check if the login was successful
//       if (response.ok || response.status === 200) {
//         localStorage.setItem("authToken", data.data.token);
//         localStorage.setItem("user", JSON.stringify(data.data.user));
//         try {
//           await initializePermissions();
//         } catch (permErr) {
//           console.error("Failed to initialize permissions after login:", permErr);
//         }
//         navigate("/dashboard");
//         //  window.location.href = "/dashboard";
//       } else {
//         // Handle error case if login fails
//         setErrorMessage(data.message || "Login failed. Please try again.");
//       }
//     } catch (error) {
//       // Handle network or other errors
//       setErrorMessage("An error occurred. Please try again later.");
//       console.error("Error during login:", error);
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   return (
//     <div className="container" style={styles.container}>
//       <div id="page-container" style={styles.pageContainer}>
//         <div className="login" style={styles.login}>
//           <div className="login-cover" style={styles.loginCover}></div>
//           <div className="login-content" style={styles.loginContent}>
//             <div className="login-brand" style={styles.loginBrand}>
//               <img src={logo} alt="Streetgains" style={styles.logo} />
//             </div>
//             <div className="loginbox" style={styles.loginbox}>
//               {errorMessage && <div style={styles.error}>{errorMessage}</div>}
//               <form name="loginForm" id="loginForm" onSubmit={handleSubmit}>
//                 <div className="form-group" style={styles.formGroup}>
//                   <label htmlFor="identity" className="control-label">
//                     Username
//                   </label>
//                   <input
//                     type="text"
//                     name="identity"
//                     id="identity"
//                     placeholder="Enter Username"
//                     className="form-control"
//                     style={styles.formControl}
//                     value={identity}
//                     onChange={(e) => setIdentity(e.target.value)}
//                   />
//                 </div>
//                 <div className="form-group" style={styles.formGroup}>
//                   <label htmlFor="password" className="control-label">
//                     Password
//                   </label>
//                   <input
//                     type="password"
//                     name="password"
//                     id="password"
//                     placeholder="Enter Password"
//                     className="form-control"
//                     style={styles.formControl}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   style={styles.submitButton}
//                   disabled={loading} // Disable button when loading
//                 >
//                   {loading ? "Signing In..." : "Sign In"}
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Inline CSS styles
// const styles = {
//   container: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "100vh",
//   },
//   pageContainer: {
//     width: "100%",
//     maxWidth: "400px", // Optional: Set a maximum width for the form
//     margin: "0 auto",
//   },
//   login: {
//     display: "flex",
//     flexDirection: "column",
//     height: "auto",
//   },
//   loginCover: {
//     background: "#ffffff !important",
//     flex: "1",
//     // position: "relative",
//   },
//   loginContent: {
//     padding: "2rem",
//     boxShadow: "-1px -2px 10px 0px rgba(0,0,0,0.75)",
//   },
//   loginBrand: {
//     textAlign: "center",
//   },
//   logo: {
//     width: "100%",
//   },
//   formGroup: {
//     marginBottom: "15px",
//   },
//   formControl: {
//     background: "rgba(0, 0, 0, 0.1)",
//     border: "1px solid rgba(0,0,0,0.1)",
//     color: "#000",
//     width: "100%",
//   },
//   submitButton: {
//     width: "100%",
//     marginTop: "10px",
//   },
//   error: {
//     color: "red",
//     marginBottom: "15px",
//   },
// };

// export default Login;



import React, { useState, useEffect } from "react";
import logo from "../assets/img/street-logo.png";
import { API_URL } from "../config"; // Import the global API URL
import { useNavigate } from "react-router-dom";
import { initializePermissions, hasPermission } from "../helpers/permission";
import { showToast } from "../components/toast";


const Login = () => {
  const [identity, setIdentity] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false); // Track loading state
  const navigate = useNavigate(); // Initialize useNavigate hook

  useEffect(() => {
    const isSessionExpired = localStorage.getItem("sessionExpired");
    if (isSessionExpired) {
      showToast.error("Session expired. Please login again.");
      localStorage.removeItem("sessionExpired");
    }
  }, []);

  const clearSiteCache = async () => {
    // Service Worker cache
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    console.log("Cache cleared successfully");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!identity || !password) {
      setErrorMessage("Username and password are required.");
      return;
    }

    setErrorMessage("");
    setLoading(true);

    try {
      // ✅ CLEAR CACHE BEFORE LOGIN
      await clearSiteCache();

      const fcmToken = localStorage.getItem("fcm_token") || localStorage.getItem("fcmToken");

      const loginData = {
        identity,
        password,
        ...(fcmToken ? { fcm_token: fcmToken } : {}),
      };

      const response = await fetch(`${API_URL}auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("authToken", data.data.token);
        localStorage.setItem("user", JSON.stringify(data.data.user));

        await initializePermissions();
        if (
          hasPermission("distributor_dashboard", "view") &&
          !hasPermission("dashboard", "view")
        ) {
          navigate("/distributor-dashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        setErrorMessage(data.message || "Login failed. Please try again.");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again later.");
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container" style={styles.container}>
      <div id="page-container" style={styles.pageContainer}>
        <div className="login" style={styles.login}>
          <div className="login-cover" style={styles.loginCover}></div>
          <div className="login-content" style={styles.loginContent}>
            <div className="login-brand" style={styles.loginBrand}>
              <img src={logo} alt="Streetgains" style={styles.logo} />
            </div>
            <div className="loginbox" style={styles.loginbox}>
              {errorMessage && <div style={styles.error}>{errorMessage}</div>}
              <form name="loginForm" id="loginForm" onSubmit={handleSubmit}>
                <div className="form-group" style={styles.formGroup}>
                  <label htmlFor="identity" className="control-label">
                    Username
                  </label>
                  <input
                    type="text"
                    name="identity"
                    id="identity"
                    placeholder="Enter Username"
                    className="form-control"
                    style={styles.formControl}
                    value={identity}
                    onChange={(e) => setIdentity(e.target.value)}
                  />
                </div>
                <div className="form-group" style={styles.formGroup}>
                  <label htmlFor="password" className="control-label">
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Enter Password"
                    className="form-control"
                    style={styles.formControl}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={styles.submitButton}
                  disabled={loading} // Disable button when loading
                >
                  {loading ? "Signing In..." : "Sign In"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Inline CSS styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  pageContainer: {
    width: "100%",
    maxWidth: "400px", // Optional: Set a maximum width for the form
    margin: "0 auto",
  },
  login: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
  },
  loginCover: {
    background: "#ffffff !important",
    flex: "1",
    // position: "relative",
  },
  loginContent: {
    padding: "2rem",
    boxShadow: "-1px -2px 10px 0px rgba(0,0,0,0.75)",
  },
  loginBrand: {
    textAlign: "center",
  },
  logo: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "15px",
  },
  formControl: {
    background: "rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0,0,0,0.1)",
    color: "#000",
    width: "100%",
  },
  submitButton: {
    width: "100%",
    marginTop: "10px",
  },
  error: {
    color: "red",
    marginBottom: "15px",
  },
};

export default Login;
